import { useMutation,useQuery } from "@apollo/client";

import { createInquiryForm, deleteInquiryForm,updateInquiryForm, updateInquiryFormMetadata } from "./mutations";
import { inquiryFormsList, pageTypesQuery } from "./queries";

export const useInquiryFormsListQuery = (options?: any) => {
  return useQuery(inquiryFormsList, options);
};

export const useInquiryFormPageTypesQuery = (options?: any) => {
  return useQuery(pageTypesQuery, options);
};

export const useCreateInquiryFormMutation = (options?: any) => {
  return useMutation(createInquiryForm, options);
};

export const useUpdateInquiryFormMetadataMutation = (options?: any) => {
  return useMutation(updateInquiryFormMetadata, options);
};

export const useUpdateInquiryFormMutation = (options?: any) => {
  return useMutation(updateInquiryForm, options);
};

export const useDeleteInquiryFormMutation = (options?: any) => {
  return useMutation(deleteInquiryForm, options);
};